import React from "react"
import { graphql } from "gatsby"
import Header from "../components/header"
import "../components/layout.css"
import SEO from "../components/seo"

export default ({ data }) => {
  const post = data.markdownRemark
  return (
    <main>
      <Header />
      <SEO title={post.frontmatter.title} description="my own pace..." />
      <div className="container mb-10 mx-auto">
        <div className="px-6">
          <div className="p-8 bg-white rounded shadow">
            <h1 className="text-3xl font-bold">{post.frontmatter.title}</h1>
            <p className="mt-6 text-gray-500 px-2 mb-4">
              {post.frontmatter.date}
            </p>
            <div
              className="px-2 blogcontent"
              dangerouslySetInnerHTML={{
                __html: post.html,
              }}
            />
          </div>
        </div>
      </div>
    </main>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        date(formatString: "YYYY.MM.DD")
      }
    }
  }
`
